import { render } from "./PasswordResetSub.vue?vue&type=template&id=9ece5df2&ts=true"
import script from "./PasswordResetSub.vue?vue&type=script&lang=ts"
export * from "./PasswordResetSub.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/www-root/data/www/brazilist-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__